const awsconfig = {
    Auth: {
        region: "us-east-2",
        userPoolId: "us-east-2_EjE8AenDg",
        userPoolWebClientId: "76n16rclenkfqu2jrhmfe7lm61"
    }
};

export default awsconfig;